import { For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { isReachable } from '../lib/memberships';
import type { MembershipView } from '../lib/session';
import { IdentityLinkForm } from './IdentityLinkForm';
import { Panel } from './Panel';

// The orgs whose own login this person could link (#466): a membership THIS
// session can open (the API refuses a link from a session pinned elsewhere, and
// sends an unreachable row `sso: null` anyway), whose org has an enabled IdP
// (`sso`) that this user does not hold yet (`!sso.linked`).
// Presenter: the route hands the memberships in.

type Linkable = { readonly slug: string; readonly org: string };

export function IdentityLinkPanel(props: {
  readonly memberships: readonly MembershipView[];
}): JSX.Element {
  const linkable = (): readonly Linkable[] =>
    props.memberships.flatMap((m) =>
      isReachable(m) && m.sso !== null && !m.sso.linked
        ? [{ slug: m.sso.slug, org: m.github_login ?? m.sso.slug }]
        : [],
    );
  return (
    <Panel title={t('logins.link_title')} class="identity-links__panel">
      <p class="identity-links__lead">{t('logins.link_desc')}</p>
      <Show
        when={linkable().length > 0}
        fallback={<p class="list-empty">{t('logins.link_none')}</p>}
      >
        <ul class="identity-links">
          <For each={linkable()}>
            {(l) => (
              <li>
                <IdentityLinkForm slug={l.slug} org={l.org} />
              </li>
            )}
          </For>
        </ul>
      </Show>
    </Panel>
  );
}
